import React, {Component} from 'react'
import ModalEditStatus from "./ModalEditStatusV3"
import { Tooltip } from 'antd'

class ProductionStatus extends Component {
    state = {
        isOpen: false,
    }

    _handleClose = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleOpen = e => {
        e.preventDefault()

        this.setState({
            isOpen: true
        })
    }

    render() {
        const {item, reloadItems, roles} = this.props
        const {production_status} = item
        const itemStatus = item.hasOwnProperty('sub_status') && item.sub_status ? item.sub_status : production_status
        const {isOpen} = this.state

        return (
            <div className="ProductionStatus">
                <label>Status: </label> {itemStatus}
                {
                    (production_status !== 'cancelled' && production_status !== 'cancel-ship') && (
                        <div className="d-inline-block">
                            <Tooltip title="Edit Status">
                                <i aria-label="Change status" onClick={this._handleOpen} className="icon-pencil ml-1 cursor-pointer" style={{fontSize: 14}}/>
                            </Tooltip>
                            
                            <ModalEditStatus onClose={this._handleClose} reloadItems={reloadItems} isOpen={isOpen} item={item}
                                             status={item.production_status} roles={roles}/>
                        </div>
                    )
                }
            </div>
        )
    }
}

export default ProductionStatus
